import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { wizardClasses } from 'Views/Page/Content/Templates/WizardTemplates/wizardCommonStyles';
import InstitutionHeader from 'Components/ComponentLibrary/Molecules/InstitutionHeader/InstitutionHeader';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import useMobileLayout from 'Hooks/useMobileLayout';
import fr from 'facet-rest';
import { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { onExit } from 'Components/ComponentLibrary/Organisms/SelectInstitution/onExit';

export const onFailedToLinkContentPrimaryAction = async (resource, logStandardizedEvent, loadContent, history) => {
  const onManuallyAdd = resource.withRelationship(fr.relationships.addManually.name,
    async (rel) => {
      logStandardizedEvent(categories.addAccounts, eventTypes.failedToLinkAccounts, eventSubTypes.addAccountsManually, {
        eventProperties: {
          institution: resource.attr('name'),
        },
      });
      loadContent(rel.link('related'));
    },
    () => null);

  const onRedirectOnExit = resource.withRelationship(fr.relationships.redirectOnExit.name,
    async () => {
      onExit(
        resource,
        (link) => loadContent(link),
        logStandardizedEvent,
        history,
      );
    },
    () => null);

  if (onManuallyAdd) {
    return onManuallyAdd;
  }

  return onRedirectOnExit;
};

export const onFailedToLinkContentSpecificLinkClicked = async (resource, logStandardizedEvent, loadContent) => {
  return resource.withRelationship(fr.relationships.specificPageLink.name,
    async (rel) => {
      logStandardizedEvent(categories.addAccounts, eventTypes.failedToLinkAccounts, eventSubTypes.exiting);
      if (rel.meta('submitResourceBefore') === true) {
        await resource.submit();
      }
      loadContent(rel.link('related'));
    },
    () => null);
};

const styles = (theme) => ({
  root: {
    ...wizardClasses.root(theme),
  },
  container: {
    ...wizardClasses.container(theme),
  },
  desktopContainer: {
    ...wizardClasses.container(theme),
    maxWidth: theme.dimensions.lg,
  },
  content: {
    ...wizardClasses.content(theme),
    rowGap: theme.spacing(5),
    paddingTop: theme.spacing(2),
  },
  link: {
    paddingBottom: theme.spacing(5),
  },
  setupManually: {
    paddingTop: theme.spacing(5),
  },
});

const FailedToLinkContent = ({
  className,
  classes,
  resource,
}) => {
  const isMobile = useMobileLayout();

  const logo = resource.attr('logo');
  const name = resource.attr('institutionName');

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <InstitutionHeader logo={logo} name={name} />
      <Box className={classNames(classes.container, {
        [classes.desktopContainer]: !isMobile,
      })}
      >
        <Box className={classes.content}>
          <Title value={resource.attr('title')} test={'failed-to-link-title'} />
          <Subtitle value={resource.attr('subtitle')} />
        </Box>
      </Box>
    </Box>
  );
};

FailedToLinkContent.defaultProps = {
  className: '',
};

FailedToLinkContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(FailedToLinkContent);
